export default {"src":"/_next/static/media/compliance.9afc00ea.svg","height":21,"width":20};